export const isDevEnvironment = () => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return url.includes('localhost');
};

export const isStagingEnvironment = () => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return url.includes('dev.agentous.ai');
};

export const passwordRequirements = [
  {
    id: 'minLength',
    label: 'At least 8 characters',
    isMet: (password: string) => password.length >= 8,
  },
  {
    id: 'uppercase',
    label: 'One uppercase letter',
    isMet: (password: string) => /[A-Z]/.test(password),
  },
  {
    id: 'lowercase',
    label: 'One lowercase letter',
    isMet: (password: string) => /[a-z]/.test(password),
  },
  {
    id: 'number',
    label: 'One number',
    isMet: (password: string) => /\d/.test(password),
  },
  {
    id: 'specialCharacter',
    label: 'One special character',
    isMet: (password: string) => /[^A-Za-z0-9\s]/.test(password),
  },
  {
    id: 'noSpaces',
    label: 'No spaces',
    isMet: (password: string) => !/\s/.test(password),
  },
];

export const passwordRequirementMessage =
  'Password must be at least 8 characters and include one uppercase letter, one lowercase letter, one number, one special character, and no spaces.';

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9\s])\S{8,}$/;

export const phoneRegExp =
  /^((\+[1-9][ \\-]*)|(\\(\d\\)[ \\-]*)|(\d)[ \\-]*)*?\d?[ \\-]*\d?$/;
export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const emailReplaceCharacterRegex = (emailString: string) => {
  if (emailString.trim() === '') {
    return emailString;
  }
  const [username, domain] = emailString.split('@');
  const obfuscatedUsername =
    username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
  const obfuscatedDomain =
    domain.charAt(0) + '*'.repeat(domain.length - 2) + domain.slice(-1);

  return `${obfuscatedUsername}@${obfuscatedDomain}`;
};
